import { RESET } from '../actionTypes';
import { productDatasheetsActions } from '../reducer';

export default () => productDatasheetsActions[RESET]();
